import React from "react";
import PropTypes from "prop-types";

import StarsIcon from "@mui/icons-material/Stars";

import { getFieldValueFromSearchParams } from "../../../helpers/methods";

import useFillterButton from "../../../hooks/useFilterButton";
import usePaginationWithSearchParams from "../../../hooks/usePaginationWithSearchParams";

import { IconButton } from "@mui/material";

function IsFeedbackFilter(props) {
  const { searchParams, getFilterFieldKey } = usePaginationWithSearchParams(
    props.filterPrefix,
  );
  const { handleClickFilterButton } = useFillterButton(props.filterPrefix);

  const filterValue = getFieldValueFromSearchParams(
    searchParams,
    getFilterFieldKey(props.isFeedbackFilterKey),
  );

  const handleClickFilter = (filterValue) => {
    handleClickFilterButton(filterValue, props.isFeedbackFilterKey);
  };

  const getDotFilter = () => {
    if (filterValue === "false")
      return (
        <IconButton onClick={() => handleClickFilter(undefined)}>
          <StarsIcon fontSize="small" sx={{ color: "#999" }} />
        </IconButton>
      );

    if (filterValue === "true")
      return (
        <IconButton onClick={() => handleClickFilter(false)}>
          <StarsIcon fontSize="small" color="success" />
        </IconButton>
      );

    return (
      <IconButton onClick={() => handleClickFilter(true)}>
        <StarsIcon fontSize="small" sx={{ color: "var(--white)" }} />
      </IconButton>
    );
  };

  return getDotFilter();
}

IsFeedbackFilter.propTypes = {
  filterPrefix: PropTypes.string,
  isFeedbackFilterKey: PropTypes.string,
};

IsFeedbackFilter.defaultProps = {
  isFeedbackFilterKey: "is_feedback",
};

export default IsFeedbackFilter;
